module.exports = __webpack_public_path__ + "static/media/tsugumomo2.7d6a1874.png";